import { render, staticRenderFns } from "./NewsForm.vue?vue&type=template&id=a75a46a4&scoped=true"
import script from "./NewsForm.vue?vue&type=script&lang=js"
export * from "./NewsForm.vue?vue&type=script&lang=js"
import style0 from "./NewsForm.vue?vue&type=style&index=0&id=a75a46a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a75a46a4",
  null
  
)

export default component.exports